module.exports = __webpack_public_path__ + "static/media/more@2x.b2e003a9.png";